﻿export const GEOM_POINT = 'POINT';
export const GEOM_LINE = 'LINE';
export const GEOM_POLYGON = 'POLYGON';
export const GEOM_ALL = 'ALL';